module.exports = __webpack_public_path__ + "static/media/mma-logo.3a13d3fe.png";